import { render, staticRenderFns } from "./NoticeTemplateEditor.vue?vue&type=template&id=2b0a4c3c&scoped=true"
import script from "./NoticeTemplateEditor.vue?vue&type=script&lang=js"
export * from "./NoticeTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./NoticeTemplateEditor.vue?vue&type=style&index=0&id=2b0a4c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a4c3c",
  null
  
)

export default component.exports